// @ts-nocheck
// Sales page v2 — "עמוד מתוך הספר" (Shlomo, 12.10 direction; 20-21.10 texts).
//
// The stranger arrives from a one-minute clip, not from a free chapter.
// So the page reads like a page of the book: the author, one headline in
// Shlomo's words, the "why I wrote it" film, and only then the door
// (the live PaywallGate card in its slim variant). No back door to free
// chapters (Shlomo 29.8/30.8).
//
// Route: /b2 (hidden until Shlomo says "ערוכים"; /b stays live).

import { useEffect, useRef, useState } from "react";
import { PaywallGate } from "./PaywallGate";
import { CHAPTER_PICKS } from "../data/chapterPicks";
import { logSiteEvent } from "../lib/siteEvents";

const MEDIA = "https://aflefkolkkxesvtdwyfd.supabase.co/storage/v1/object/public/media/film";
const VIDEO_FULL = `${MEDIA}/why-full-720.mp4`;
const VIDEO_SHORT = `${MEDIA}/why-60-720.mp4`;
const POSTER = `${MEDIA}/why-poster.jpg`;

// Display titles for the chapter list (the ToC titles of 2, 8 and 11 are
// long; here one line each, same numbering as the book).
const SHORT: Record<number, string> = {
  2: "מערכת ההישרדות",
  3: "אינטליגנציה רגשית: ארגז הכלים",
  7: "הורמונים וארבעת הערוצים",
  8: "מקורות היניקה ועצב הוואגוס",
  11: "אהבה, פילוסופיה, בודהיזם",
};

// "דבר המחבר" — Shlomo's text (final wording 18.10), shown in full behind
// "הטקסט המלא"; the four lines above it are the heart of it.
const WHY_FULL = [
  "כולם רצים אחרי יכולות מחשוב מטורפות. גם אני. את הספר הזה כתבתי בעזרתן, ונהניתי מכל רגע.",
  "אבל הכלים האלה לא באים מעצמם. בני אדם מביאים אותם, ובני אדם מכוונים אותם. והיום, רוב הזמן, הם מכוונים לפחד. לתמוך במי שמייצר קונספירציות, בהלה וכעס. כי פחד מוכר. זה מסוכן לאדם. מסוכן לעולם. ובסוף, מסוכן גם לתעשייה הזו עצמה.",
  "ובכלים האלה יש כללים. קל, ממש קל, לכתוב בהם הגדרות שתומכות באהבה במקום בפחד. השאלה היא רק מי יכתוב אותן.",
  "נדמה לנו שאנחנו רודפים אחרי חיים טובים, מהנים ובריאים. במבחן התוצאה אנחנו רודפים אחרי משהו אחר. עוד כוח. עוד משאבים, עוד שליטה, להגיע ראשונים. כדור הארץ יסתדר. הוא כאן עוד מיליארדי שנים, גם אם יהיה לו חם יותר בגללנו. השאלה היא מה איתנו. מין שכבר כבש את הכדור, ועדיין נלחם בעצמו כמעט בכל פינה שלו.",
  "אני אומר את זה בלי לרכך. הדבר שהורס את העולם יותר מכל דבר אחר הוא הדת, כשהיא יוצאת מהבית. דת שייכת לבית. לשולחן. ללב. ברגע שהיא עוברת לבית תפילה ציבורי, ומשם לרחוב, ומשם לשלטון, היא הופכת מכלי של אהבה לכלי של כוח. וכוח, כשמסתכלים עליו מקרוב, הוא תמיד פחד.",
  "כי אנחנו מופעלים משני עולמות רגש. אהבה. ופחד. כשיש אלימות, הפחד שולט. כשיש שלום, האהבה שולטת.",
  "ופחד, חשוב לדייק, הוא לא דבר שממתנים. כשיש אריה אמיתי, שום תובנה לא תעצור את הגוף שלך. וטוב שכך. אבל כשאין אריה, ורוב הזמן אין, את הפחד לא ממתנים. ממגרים אותו. כל הספר הזה הוא ההבחנה הזו. יש כאן אריה?",
  "לכן אני מאמין שאינטליגנציה רגשית צריכה להיות המקצוע הראשון שלומדים. לפני חשבון. לפני אנגלית. מגן הילדים ועד האוניברסיטה. בכל העולם. לא כשיעור העשרה. כמקצוע ליבה. עם מורים. עם מבחנים. עם ציון בתעודה.",
  "מה לומדים בו? לזהות רגש כשהוא עולה. להבחין בין פחד אמיתי לפחד כזב. להקשיב למישהו עד הסוף, בלי לתקן אותו באמצע. לחיות עם אנשים ששונים ממך, בלי שהם ייהפכו לאיום. ולדעת שאין \"צריך\". יש רק \"רוצה\". והאחריות על מה שאני עושה היא שלי.",
  "ותחשבי על עולם שבו דור שלם למד את זה מגיל חמש. צעירים מגדלים ילדים מבחירה. לא מטעות. אנשים שחיים בפרנויה לא מגיעים לעמדות של קבלת החלטות, כי כולם סביבם יודעים לזהות את זה. התקשורת מפסיקה לסחור בפחד, כי הפחד הפסיק למכור. ומלחמות? כן. מלחמות נעלמות. לא כי האנשים נהיו טובים יותר. אלא כי הם למדו לראות כשאין אריה.",
  "עד שזה יקרה, יש את הספר הזה. הוא ההצבעה שלי. לחזק את האהבה. ולמגר את הפחד שאין לו אריה.",
];

const styles = `
/* Type scale (Shlomo 21.10: "יותר מדי סוגי פונטים"): two families only -
   Frank Ruhl Libre for headings at 26 / 20, Heebo for everything else at 17 / 14. */
.sp { background: #FFFDF9; min-height: 100vh; direction: rtl; font-family: 'Heebo', sans-serif; color: #2D1B10; font-size: 17px; line-height: 1.7; }
.sp-wrap { max-width: 680px; margin: 0 auto; padding: 22px 18px 24px; }
.sp h1, .sp h2, .sp .sp-sec-h, .sp .sp-video-head { font-family: 'Frank Ruhl Libre', serif; font-weight: 800; color: #2D1B10; line-height: 1.3; margin: 0; }
.sp-author { display: flex; align-items: center; gap: 12px; margin: 0 0 18px; }
.sp-face { width: 58px; height: 58px; border-radius: 50%; object-fit: cover; flex: none; border: 2px solid #E8DCC8; }
.sp-author b { display: block; font-size: 17px; font-weight: 700; color: #5C3D2E; line-height: 1.3; }
.sp-author span { display: block; font-size: 14px; color: #6b5444; line-height: 1.5; margin-top: 2px; }
.sp-h1 { font-size: 26px; margin: 0 0 10px; }
.sp-sub { margin: 0 0 14px; }
.sp-sub strong { color: #5C3D2E; }
.sp-jump { display: inline-block; background: #5C3D2E; color: #F6EEE2; border-radius: 10px; padding: 11px 20px; font-weight: 700; font-size: 17px; text-decoration: none; cursor: pointer; border: none; font-family: 'Heebo', sans-serif; line-height: 1.3; }
.sp-jump small { display: block; font-size: 14px; font-weight: 400; opacity: .85; margin-top: 2px; }
.sp-video { margin: 24px 0 10px; }
.sp-video-head { font-size: 20px; margin: 0 0 4px; }
.sp-video-sub { font-size: 14px; color: #6b5444; margin: 0 0 10px; }
.sp-video video { width: 100%; max-width: 360px; aspect-ratio: 9/16; display: block; margin: 0 auto; border-radius: 14px; background: #000; }
.sp-video-switch { text-align: center; font-size: 14px; color: #8B7355; margin: 8px 0 0; }
.sp-video-switch a { color: #A0704A; font-weight: 700; cursor: pointer; text-decoration: underline; }
.sp-why { margin: 18px 0 8px; border-right: 3px solid #D4875A; padding: 4px 14px 4px 0; }
.sp-why p { margin: 0 0 10px; color: #3f2c1f; }
.sp-why summary { cursor: pointer; color: #A0704A; font-weight: 700; font-size: 14px; list-style: none; }
.sp-why summary::-webkit-details-marker { display: none; }
.sp-why details p { margin: 10px 0 0; }
.sp-offer { margin: 26px 0 0; }
.sp .paywall-wrap { padding-bottom: 0; }
.sp-sec { margin: 26px 0 0; }
.sp-sec-h { font-size: 20px; margin: 0 0 4px; }
.sp-sec-sub { font-size: 14px; color: #6b5444; margin: 0 0 14px; }
.sp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.sp-card { background: #FFF8F0; border: 1px solid #E8DCC8; border-radius: 14px; padding: 12px 14px 12px 12px; display: flex; gap: 10px; align-items: flex-start; }
.sp-num { flex: none; width: 30px; height: 30px; border-radius: 50%; background: #D4875A; color: #fff; font-weight: 700; font-size: 14px; display: flex; align-items: center; justify-content: center; margin-top: 1px; }
.sp-card b { display: block; font-size: 17px; font-weight: 700; color: #2D1B10; line-height: 1.35; margin-bottom: 3px; }
.sp-card span { display: block; font-size: 14px; color: #6b5444; line-height: 1.55; }
.sp-qgrid { display: grid; grid-template-columns: 1fr; gap: 10px; }
.sp-q { background: #fff; border: 1px solid #E8DCC8; border-radius: 14px; padding: 14px 16px 12px; position: relative; }
.sp-qm { position: absolute; top: -8px; right: 12px; font-family: 'Frank Ruhl Libre', serif; font-size: 46px; color: #D4875A; line-height: 1; }
.sp-q p { margin: 0 0 8px; padding-right: 22px; color: #2D1B10; }
.sp-q div { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #8B7355; }
.sp-q i { font-style: normal; width: 26px; height: 26px; border-radius: 50%; background: #E8DCC8; color: #5C3D2E; font-weight: 700; display: flex; align-items: center; justify-content: center; font-size: 14px; }
.sp-close { margin: 34px 0 10px; background: linear-gradient(135deg, #1E2A44, #34507A); border-radius: 20px; padding: 26px 22px 24px; text-align: center; color: #F6EEE2; box-shadow: 0 12px 34px rgba(30,42,68,0.28); }
.sp-close img { width: 76px; height: 76px; border-radius: 50%; object-fit: cover; border: 3px solid #F0C27B; display: block; margin: 0 auto 10px; }
.sp-close h2 { font-size: 26px; color: #F0C27B; margin: 0 0 8px; }
.sp-close p { margin: 0 auto 16px; max-width: 460px; color: #F6EEE2; }
.sp-close button { background: #F0C27B; color: #2D1B10; border: none; border-radius: 14px; padding: 14px 26px; font-family: 'Heebo', sans-serif; font-size: 17px; font-weight: 700; cursor: pointer; box-shadow: 0 6px 18px rgba(0,0,0,0.25); line-height: 1.3; }
.sp-close button small { display: block; font-size: 14px; font-weight: 400; margin-top: 2px; }
.sp-close .sp-fine { font-size: 14px; color: #cfd8ea; margin: 12px 0 0; }
/* The slim payment card inherits the same scale (overrides scoped to this page). */
.sp .paywall-email-title { font-size: 20px; }
.sp .paywall-cta, .sp .paywall-gift-banner-cta { font-size: 17px !important; }
.sp .paywall-gift-banner-title { font-size: 20px; }
.sp .paywall-email-note, .sp .paywall-heard-q, .sp .paywall-heard-opt, .sp .paywall-gift-banner-kicker, .sp .paywall-gift-banner-sub, .sp .paywall-trust span, .sp .paywall-survey-q, .sp .paywall-survey-opt, .sp .paywall-fine, .sp .paywall-fine a, .sp .paywall-pay-note { font-size: 14px; }
@media (max-width: 560px) { .sp-grid { grid-template-columns: 1fr; } }
`;

export function SalesPage() {
  const [short, setShort] = useState(false);
  const vref = useRef<HTMLVideoElement>(null);
  const played = useRef(false);

  useEffect(() => {
    logSiteEvent("b2_view");
  }, []);

  const jump = () => {
    logSiteEvent("b2_cta");
    document.getElementById("b2-offer")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="sp">
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className="sp-wrap">
        <div className="sp-author">
          <img className="sp-face" src="/about/shlomo.jpg" alt="שלמה אלפנבוים" />
          <div>
            <b>שלמה אלפנבוים</b>
            <span>20 שנה מנחה את הסדנה הזו, באל על, באגד ובצה"ל. עכשיו היא בספר, בקולי.</span>
          </div>
        </div>

        <h1 className="sp-h1">12 פרקים. אתם בוחרים את הסדר, את הקצב ואת הדרך.</h1>
        <p className="sp-sub">
          מתקדמים לפי העניין שמעוררות הכותרות. מאזינים, קוראים, או גם וגם. ובסוף כל
          סעיף שאלה ומסגרת לכתוב בה: <strong>התשובות שלכם נשמרות ומלוות אתכם לאורך כל הסדנה.</strong>
        </p>
        <button className="sp-jump" onClick={jump}>
          לפתוח את כל הסדנה, 89 ₪
          <small>פעם אחת, לתמיד. ביט או כרטיס.</small>
        </button>

        <div className="sp-video">
          <div className="sp-video-head">למה כתבתי את הספר הזה</div>
          <div className="sp-video-sub">{short ? "שלמה, בדקה אחת." : "שלמה, בארבע דקות. בלי לרכך."}</div>
          <video
            key={short ? "s" : "f"}
            ref={vref}
            src={short ? VIDEO_SHORT : VIDEO_FULL}
            poster={POSTER}
            controls
            playsInline
            preload="metadata"
            controlsList="nodownload"
            onPlay={() => {
              if (!played.current) {
                played.current = true;
                logSiteEvent("b2_video");
              }
            }}
          />
          <div className="sp-video-switch">
            {short ? (
              <>רוצים את כל הדברים? <a onClick={() => setShort(false)}>הגרסה המלאה, 4 דקות</a></>
            ) : (
              <>אין ארבע דקות? <a onClick={() => setShort(true)}>הגרסה של דקה</a></>
            )}
          </div>
        </div>

        <div className="sp-why">
          <p>אנחנו מופעלים משני עולמות רגש. אהבה. ופחד.</p>
          <p>כשיש אריה אמיתי, שום תובנה לא תעצור את הגוף שלך. וטוב שכך. אבל כשאין אריה, ורוב הזמן אין, את הפחד לא ממתנים. ממגרים אותו.</p>
          <p>כל הספר הזה הוא ההבחנה הזו. יש כאן אריה?</p>
          <details>
            <summary>דבר המחבר, הטקסט המלא ←</summary>
            {WHY_FULL.map((t, i) => (
              <p key={i}>{t}</p>
            ))}
          </details>
        </div>

        <div className="sp-offer" id="b2-offer">
          <PaywallGate
            chapter={2}
            chapterTitle=""
            variant="slim"
            onBackToChapter1={() => {
              window.location.href = "/";
            }}
          />
        </div>

        <div className="sp-sec">
          <div className="sp-sec-h">מה מחכה בפנים</div>
          <div className="sp-sec-sub">12 פרקים, כל אחד נפתח ברגע מהחיים ונגמר בכלי. בוחרים מאיפה להתחיל.</div>
          <div className="sp-grid">
            {CHAPTER_PICKS.map((c) => (
              <div className="sp-card" key={c.n}>
                <div className="sp-num">{c.n}</div>
                <div>
                  <b>{SHORT[c.n] || c.title}</b>
                  <span>{c.line}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="sp-sec">
          <div className="sp-sec-h">מה אומרים משתתפי הסדנאות</div>
          <div className="sp-qgrid">
            <div className="sp-q"><span className="sp-qm">„</span><p>זה כל כך פשוט וכל כך עובד, שזה מטורף.</p><div><i>נ</i>ניב, משתתף סדנה</div></div>
            <div className="sp-q"><span className="sp-qm">„</span><p>שמעתי, לא האמנתי, עד שניסיתי. ומאז זה כבר באוטומט.</p><div><i>א</i>אלונה, משתתפת סדנה</div></div>
            <div className="sp-q"><span className="sp-qm">„</span><p>שינוי כזה צפוי היה להיות ארוך ומורכב. אבל לא כאן. זה אשכרה פטנט רגשי.</p><div><i>י</i>ירון, משתתף סדנה</div></div>
          </div>
        </div>

        <div className="sp-close">
          <img src="/about/shlomo.jpg" alt="" />
          <h2>אני מחכה לך בפנים.</h2>
          <p>קורס חי כזה עולה 3,000 עד 4,000 ₪. כאן 89 ₪, פעם אחת, לתמיד, כי אני רוצה שזה יגיע לכולם.</p>
          <button onClick={jump}>
            לפתוח את כל הסדנה, 89 ₪
            <small>ביט או כרטיס. קישור כניסה למייל, בלי סיסמה.</small>
          </button>
          <div className="sp-fine">שאלה לפני? וואטסאפ לשלמה 054-4562084</div>
        </div>
      </div>
    </div>
  );
}
